var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var trackEvent = function (getUtag, viewData, getEventData) {
    return getUtag()
        .then(function (utag) {
        var eventData = getEventData();
        var data = __assign(__assign({}, viewData), { event: eventData });
        utag.link(data);
    })
        .catch(function (e) {
        console.warn("@argonaut/analytics trackEvent was unable to get utag", e);
    });
};
//# sourceMappingURL=trackEvent.js.map